<main id="main-content" class="main-content">
  <h2 class="form-header">2. Burned Area Description</h2>

  <mat-card [formGroup]="form">
    <div class="title">FIRE DETAILS</div>

    @if (report().assessment) {
      <div style="display: flex; flex-wrap:wrap">
        <div class="data-div" style="flex: 100%">
          <p class="data-title">Fire or Complex Name</p>
          <p class="data-info">{{report().baer_name ?? "--"}}</p>
        </div>
        <div class="data-div">
          <p class="data-title">Fire Number</p>
          <p class="data-info">{{report().IRWIN_unique_fire_identifier ?? "--"}}</p>
        </div>
        <div class="data-div" style="flex: 66%">
          <p class="data-title">Fire Incident Job Code</p>
          <p class="data-info">{{report().job_code ?? "--"}}</p>
        </div>
        <div class="data-div">
          <p class="data-title">Fire Start Date</p>
          <p class="data-info">{{this.report().fire_discovery_date | date:"MM/dd/yyyy" | empty_check}}</p>
        </div>
        <div class="data-div">
          <p class="data-title">Estimated Containment Date</p>
          <p class="data-info">{{this.report().containment_date_est | date:"MM/dd/yyyy" | empty_check}}</p>
        </div>
        <div class="data-div">
          <p class="data-title">Containment Status</p>
          <p class="data-info">{{this.report().percent_contained}}% as of {{this.report().containment_date | date:"MM/dd/yyyy" | empty_check}}</p>
        </div>
      </div>
    }
    <div class="bar">&nbsp;</div>
    <div class="title">FIRE LOCATION <span class="gis-source-text"><b>Data source:</b> GIS Database</span></div>
    @if (report().assessment) {
      <div style="display: flex; flex-wrap:wrap">
        <div class="data-div">
          <p class="data-title">Region</p>
          <p class="data-info">{{report().assessment.region ?? "--"}}</p>
        </div>
        <div class="data-div">
          <p class="data-title">State of Fire Origin</p>
          <p class="data-info">{{report().assessment.IRWIN_POO_state ?? "--"}}</p>
        </div>
        <div class="data-div">
          <p class="data-title">Forest(s)</p>
          <p class="data-info">{{report().assessment.forest_name ?? "--"}}</p>
        </div>
        <div class="data-div">
          <p class="data-title">State(s) Affected</p>
          <p class="data-info">{{states.join(", ") | empty_check}}</p>
        </div>
        <div class="data-div">
          <p class="data-title">Counties</p>
          <p class="data-info">{{counties.join(", ") | empty_check}}</p>
        </div>
        <div class="data-div">
          <p class="data-title">Ranger District(s)</p>
          <p class="data-info">{{rangerDistricts.join(", ") | empty_check}}</p>
        </div>
      </div>
    }

    @if (!simple()) {
      <div class="bar">&nbsp;</div>
      <div class="title right">Subwatershed Numbers (All NFS)</div>
      <div class="text-div" id="acres-burned-by-subwatershed-heading">
        <b>Acres Burned by Subwatershed</b>
        <br>
          <span class="gray-text">Based on all Soil Burn Severity categories: developed, unburned/very low, low, moderate,
          high.</span>
        </div>


        <!-- Table HU12# -->
        <div class="table-container">
          <table aria-labelledby="acres-burned-by-subwatershed-heading acres-burned-by-subwatershed-caption">
            <caption id="acres-burned-by-subwatershed-caption" class="usa-sr-only">
              Acres Burned by Subwatershed - HU#12, Subwatershed Name, Total Acres, Acres Burned,
              % Subwatershed Burned.
            </caption>
            <tr class="table-header">
              <th scope="col" style="display: flex">
                <div class="vert-center">HU#12</div>
                <div class="vert-center">
                  <button
                    type="button"
                    mat-icon-button
                    class="info-blue-header fa-regular fa-circle-info"
                    matTooltip='12-digit Hydrologic number'
                    matTooltipClass="tooltipClass"
                    aria-label="12-digit Hydrologic number"
                    >
                    <mat-icon>info_outline</mat-icon>
                  </button>
                </div>
              </th>
              <th scope="col">Subwatershed Name</th>
              <th scope="col" class="right">Total Acres</th>
              <th scope="col" class="right">Acres Burned</th>
              <th scope="col" class="right">% Subwatershed Burned</th>
            </tr>
            @for (watershed of report().watersheds; track watershed) {
              <tr class="table-row">
                <td class="text-cell">
                  {{ watershed.huc12 ?? "--" }}
                </td>
                <td class="text-cell">
                  {{ watershed.huc12_name ?? "--" }}
                </td>
                <td class="text-cell right">
                  {{ watershed.acres_total? (watershed.acres_total | number: '1.0-0') : "--" }}
                </td>
                <td class="text-cell right">
                  {{ watershed.acres_burned? (watershed.acres_burned | number: '1.0-0') : "--" }}
                </td>
                <td class="text-cell right">
                  {{ (100*watershed.acres_burned /
                  watershed.acres_total) | number: '1.0-0' }}%
                </td>
              </tr>
            }
          </table>
        </div>

        <div class="bar">&nbsp;</div>
        <view-image [supporting_files]="report().supporting_files"
        section="2" question="subwatershed"></view-image>

        <div class="text-div" id="total-acres-burned-heading">
          <b>Total Acres Burned</b>
          <br>
            <span class="gray-text">Acres burned by Ownership</span>
          </div>

          <!-- TABLE Ownership -->
          <table aria-labelledby="total-acres-burned-caption total-acres-burned-heading">
            <caption id="total-acres-burned-caption" class="usa-sr-only">
              Total Acres Burned - Ownership, Acres Burned, % Acres Burned.
            </caption>
            <tr class="table-header">
              <th>Ownership</th>
              <th>Acres Burned</th>
              <th>% Acres Burned</th>
            </tr>
            <ng-container formArrayName="acresBurned">
              @for (soil of report().soil_burn_severities; track soil; let i = $index) {
                <tr class="table-row">
                  @if (soil.ownership == "Other Federal") {
                    <td style="width: 70%" class="text-cell" style="display: flex; height: 70px">
                      <div class="vert-center">{{ soil.ownership }}</div>
                      <div class="vert-center">
                        <mat-icon
                          matTooltip='Other Federal: ARMY, BIA, BLM, BOP, BPA, DOD, DOE, DOI, DOT, FHA, FWS, GSA, VA, USPS, USMC, USDA, USCG, USAF, USACE, USBR, OTHFE, HHS, IBWC, LG, NAVY, NOAA, NPS, NTVALL, NTVPIC'
                          matTooltipClass="tooltipClass"
                        class="info-blue-header fa-regular fa-circle-info">info_outline</mat-icon>
                      </div>
                    </td>
                  } @else if (soil.ownership == "Private") {
                    <td style="width: 70%" class="text-cell" style="display: flex; height: 70px">
                      <div class="vert-center">{{ soil.ownership }}</div>
                      <div class="vert-center">
                        <mat-icon matTooltip='Private or Undetermined' matTooltipClass="tooltipClass"
                        class="info-blue-header fa-regular fa-circle-info">info_outline</mat-icon>
                      </div>
                    </td>
                  } @else {
                    <td style="width: 70%" class="text-cell">
                      {{ soil.ownership }}
                    </td>
                  }
                  <td class="text-cell right">
                    {{ soil.acres_burned | number: '1.0-0' }}
                  </td>
                  <td class="text-cell right">
                    {{ soil.percent_burned }}%
                  </td>
                </tr>
              }
              <tr class="sum-row">
                <td class="text-cell">
                  Total Acres Burned
                </td>
                <td class="right">
                  {{ sumAcresBurned() | number: '' }}
                </td>
                <td class="right">
                  100%
                </td>
              </tr>
            </ng-container>
          </table>
          <div class="bar">&nbsp;</div>
          <view-image [supporting_files]="report().supporting_files"
          section="2" question="acres_burned"></view-image>

          <div class="text-div">
            <b>Vegetation Types</b>
            <br>
              <span class="gray-text">Please describe the major plant communities or vegetation types in the burned area,
              include appropriate fire recurrence information if applicable.</span>
            </div>
            <div class="text" [innerHTML]="customATOB(this.report().vegetation_types || '--')"></div>
            <view-image [supporting_files]="report().supporting_files"
            section="2" question="vegetation_types"></view-image>

            <div class="text-div">
              <b>Dominant Soils</b>
              <br>
                <span class="gray-text">Please describe the soil types and topography that best characterizes the burned
                area. Use soil name that best reflect soil characteristics and level of available information.</span>
              </div>
              <div class="text" [innerHTML]="customATOB(this.report().dominant_soils || '--')"></div>
              <view-image [supporting_files]="report().supporting_files"
              section="2" question="dominant_soils"></view-image>
              <div class="text-div">
                <b>Geologic Types</b>
                <br>
                  <span class="gray-text">Please describe the geologic types and geomorphology that best characterizes the
                  burned area.</span>
                </div>
                <div class="text" [innerHTML]="customATOB(this.report().geologic_types || '--')"></div>
                <view-image [supporting_files]="report().supporting_files"
                section="2" question="geologic_types"></view-image>
                <div class="text-div" id="miles-of-stream-channels-by-type-heading">
                  <b>Miles of Stream Channels by Type</b>
                  <br>
                    <span class="gray-text">The table below shows National NHD data. A value of ‘0’ in ‘Ephemeral’ may mean data
                    has not been mapped.</span>
                  </div>

                  <!-- Table Steam Type -->
                  <table aria-labelledby="miles-of-stream-channels-by-type-heading miles-of-stream-channels-by-type-caption">
                    <caption id="miles-of-stream-channels-by-type-caption" class="usa-sr-only">
                      Miles of Stream Channels by Type - Stream Type, Forest Name, Total.
                    </caption>
                    <tr class="table-header">
                      <th>Stream Type</th>
                      @for (forest of forests; track forest) {
                        <th class="right">
                          {{ forest.forest_name }}
                        </th>
                      }
                      <th class="right last-column">Total</th>
                    </tr>
                    @for (stream of streamTypes; track stream) {
                      <tr class="table-row">
                        <td class="text-cell" style="width: 70%">
                          {{ stream }}
                        </td>
                        <ng-container>
                          @for (forest of report().forests; track forest; let i = $index) {
                            <td class="text-cell right">
                              {{ forest[fieldDict[stream]] | number: '1.0-0' | naUnfilter }}
                            </td>
                          }
                        </ng-container>
                        <td class="right last-column">
                          <b>{{ sumStream(stream) | number: '' }}</b>
                        </td>
                      </tr>
                    }
                  </table>

                  <div class="text-div" id="nfs-roads-heading">
                    <b>NFS Roads</b>
                    <br>
                      <span class="gray-text">National Forest Service Road Miles by Operational Maintenance level.</span>
                    </div>

                    <!-- Table Operational Maintenance Level -->
                    <table aria-labelledby="nfs-roads-caption nfs-roads-heading">
                      <caption id="nfs-roads-caption" class="usa-sr-only">
                        NFS Roads - Operational Maintenance Level, Forest Name.
                      </caption>
                      <tr class="table-header">
                        <th id="optionalMaitLvl">Operational Maintenance Level</th>
                        @for (forest of forests; track forest; let i = $index) {
                          <th [attr.id]="'forest-'+forest.forest_name + i" class="right">
                            {{ forest.forest_name }}
                          </th>
                        }
                      </tr>
                      @for (level of maintenanceLevels; track level) {
                        <tr class="table-row">
                          <td class="text-cell" style="width: 70%">
                            {{ level }}
                          </td>
                          <ng-container formArrayName="maintenance">
                            @for (forest of report().forests; track forest; let i = $index) {
                              <td class="text-cell right">
                                {{ forest[fieldDict[level]] | number: '1.0-0' | naUnfilter }}
                              </td>
                            }
                          </ng-container>
                        </tr>
                      }
                      <tr class="sum-row">
                        <td class="text-cell">
                          Total Road Miles
                        </td>
                        @for (forest of forests; track forest; let i = $index) {
                          <th [attr.id]="'totalRoadMiles-'+forest.forest_name + i" class="right text-cell">
                            {{ sumRoadMiles(i) | number: '' }}
                          </th>
                        }
                      </tr>
                    </table>

                    <div class="text-div short-padding" >
                      <b>Other Roads</b>
                    </div>

                    <!-- Table Other Roads -->
                    <table class="small-table" role="presentation" >
                      <tr class="table-row">
                        <td class="text-cell" style="width: 70%">
                          Other Roads
                        </td>
                        <ng-container formArrayName="maintenance">
                          @for (forest of report().forests; track forest; let i = $index) {
                            <td class="text-cell right">
                              {{ forest.other_roads | number: '1.0-0' | naUnfilter }}
                            </td>
                          }
                        </ng-container>
                      </tr>
                    </table>
                    <div class="side-line">
                      <div class="text-div">
                        <b>Additional Details</b>
                        <div class="text" [innerHTML]="customATOB(this.report().other_roads || '--')"></div>
                      </div>
                    </div>

                    <div class="text-div" id="transportation-system-heading">
                      <b>Transportation System</b>
                      <br>
                        <span class="gray-text">Forest Service Terrestrial Trail Miles by Type</span>
                      </div>

                      <!-- Table Trail Type -->
                      <table aria-labelledby="transportation-system-caption transportation-system-heading">
                        <caption id="transportation-system-caption" class="usa-sr-only">
                          Transportation System - Trail Type, Forest Name, Total.
                        </caption>
                        <tr class="table-header">
                          <th>Trail Type</th>
                          @for (forest of forests; track forest) {
                            <th class="right">
                              {{ forest.forest_name }}
                            </th>
                          }
                          <th class="right last-column">Total</th>
                        </tr>
                        @for (trail of trailTypes; track trail) {
                          <tr class="table-row">
                            <td class="text-cell" style="width: 70%">
                              {{ trail }}
                            </td>
                            <ng-container>
                              @for (forest of report().forests; track forest; let i = $index) {
                                <td class="text-cell right">
                                  {{ forest[fieldDict[trail]] | number: '1.0-0' | naUnfilter }}
                                </td>
                              }
                            </ng-container>
                            <td class="right last-column">
                              <b>{{ sumTrail(trail) | number: '' }}</b>
                            </td>
                          </tr>
                        }
                      </table>
                    }
                  </mat-card>
                </main>

                <ng-template #gisWarn>
                  <div class="yellow-warning">
                    <fa-icon [icon]="faWarning" class="faWarning" aria-label="Warning"></fa-icon>
                    <div class="support-text">
                      <b>Data source:</b> GIS data. Manual edits made below will be overwritten when GIS data is updated.
                    </div>
                  </div>
                </ng-template>
